
import DrawBase from "./DrawBase"
class DrawCone extends DrawBase {
    constructor(options) {
        super(options);
    }

    
    //左键
    leftClick(evt) {
        var $this = this;
        var position = this.getCatesian3FromPX(evt.position);
        if ($this.positions.length == 0) {
            $this.positions.push(position.clone());
        }
        $this.positions.push(position);
    }

    mouseMove(evt) {
        var $this = this;
        if ($this.positions.length < 1) return;
        var cartesian = $this.getCatesian3FromPX(evt.endPosition);
        if (!$this.Cesium.defined($this.plot)) {
            $this.plot = $this.createCone($this.positions);
            $this.entities.push($this.plot);
            $this.initEditor();
        }
        if ($this.plot) {
            $this.positions.pop();
            $this.positions.push(cartesian);
        }
    }

    initEditor() {
    }
}

export default DrawCone;